import type {Result, UseCase} from 'framework';
import type {Product} from '../../domain/product';
import type {ProductError} from '../../domain/errors';
import type {CreateManualProductInput, ProductRepository} from '../ports/product.repository';

export class CreateManualProduct implements UseCase<[CreateManualProductInput], Product> {
  constructor(private readonly repository: ProductRepository) {}

  execute(input: CreateManualProductInput): Promise<Result<Product, ProductError>> {
    return this.repository.createManual(input);
  }
}
